import { filesExtension } from "@fl/shared/src/types/models/suporte_fl/arquivos";
import axios, { AxiosRequestConfig } from "axios";
import RequestAPI from "../../..";
import StorageItems from "../../../../storage";
import { generateMessageReturn } from "../../../../utils/messageFuncs";

const auth = new StorageItems().get("authToken");

class ApiReports extends RequestAPI {
  config: AxiosRequestConfig;
  data?: any;
  token;
  basePath = "reports";
  constructor(data?: any) {
    super();
    this.token = auth?.authToken;

    this.config = {
      maxBodyLength: Infinity,
      headers: {
        "Content-Type": "application/json",
        Authorization: this.token ? `Bearer ${this.token}` : "",
      },
    };

    if (data) {
      this.data = data;
      this.config.data = data;
    }
  }

  export = async (type: filesExtension) => {
    this.config.url = `${this.baseUrl}/${this.basePath}/export/${type}`;
    this.config.method = "post";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Exportação de Relatório",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });

    return this.result;
  };

  user = async (page: number, limit: number) => {
    this.config.url = `${this.baseUrl}/${this.basePath}/user/${limit}/${page}`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Listage de Relatórios",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });

    return this.result;
  };
}

export default ApiReports;
